module.exports = __webpack_public_path__ + "static/media/sortDown.4a2339b0.svg";